const ForgotPassword = () => import('@/modules/auth/views/ForgotPassword')
const PasswordCreate = () => import('@/modules/auth/views/PasswordCreate')
const PasswordReset = () => import('@/modules/auth/views/PasswordReset')
const TwoFactorAuthentication = () => import('@/modules/auth/views/TwoFactorAuthentication')

export default [
  {
    name: 'password.create',
    path: '/password/create/:token',
    component: PasswordCreate
  },
  {
    name: 'forgot.password',
    path: '/forgot-password',
    component: ForgotPassword
  },
  {
    name: 'password.reset',
    path: '/password/reset/:token',
    component: PasswordReset
  },
  {
    name: '2f.authentication',
    path: '/two-factor-authentication',
    component: TwoFactorAuthentication
  }
]
